/* eslint-disable import/prefer-default-export */
import PQueue from 'p-queue';
import { MutationOptions, QueryOptions } from '@apollo/client';
import apolloClient from 'apolloClient';

/**
 * a queue used only for network requests (concurrency: `10`)
 */
export const defaultRequestQueue = new PQueue({ concurrency: 10 });

/**
 * a queue used only for fetchMetaBooths network requests (concurrency: `1`)
 */
export const fetchMetaBoothsRequestQueue = new PQueue({ concurrency: 1 });

/**
 * queue-based GraphQL request executor with specific queue
 */
export const requestWithQueue = (
  queue: PQueue = defaultRequestQueue,
  queryOpts: QueryOptions,
  queueConfig?: Parameters<typeof defaultRequestQueue.add>[1],
) => queue.add(
  () => apolloClient.query(queryOpts).then((result) => result.data),
  queueConfig,
);

/**
 * queue-based GraphQL mutation executor with specific queue
 */
export const mutationWithQueue = (
  queue: PQueue = defaultRequestQueue,
  mutationOpts: MutationOptions,
  queueConfig?: Parameters<typeof defaultRequestQueue.add>[1],
) => queue.add(
  () => apolloClient.mutate(mutationOpts).then((result) => result.data),
  queueConfig,
);

/**
 * queue-based GraphQL request executor with default queue
 */
export const mutate = (
  mutationOpts: MutationOptions,
  queueConfig?: Parameters<typeof defaultRequestQueue.add>[1],
) => mutationWithQueue(defaultRequestQueue, mutationOpts, queueConfig);

/**
 * queue-based GraphQL request executor with default queue
 */
export const request = (
  queryOpts: QueryOptions,
  queueConfig?: Parameters<typeof defaultRequestQueue.add>[1],
) => requestWithQueue(defaultRequestQueue, queryOpts, queueConfig);

/**
 * queue-based GraphQL request executor with fetchMetaBooths request queue
 */
export const fetchMetaBoothsRequest = (
  queryOpts: QueryOptions,
  queueConfig?: Parameters<typeof defaultRequestQueue.add>[1],
) => requestWithQueue(fetchMetaBoothsRequestQueue, queryOpts, queueConfig);
